import { render, staticRenderFns } from "./PackageComparison.vue?vue&type=template&id=7ffe88b0&scoped=true&"
import script from "./PackageComparison.vue?vue&type=script&lang=js&"
export * from "./PackageComparison.vue?vue&type=script&lang=js&"
import style0 from "./PackageComparison.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PackageComparison.vue?vue&type=style&index=1&id=7ffe88b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe88b0",
  null
  
)

export default component.exports